export const SET_USER_PRESENCE_STATUS_START =
  'SET_USER_PRESENCE_STATUS_START';
export const SET_USER_PRESENCE_STATUS_SUCCESS =
  'SET_USER_PRESENCE_STATUS_SUCCESS';
export const SET_USER_PRESENCE_STATUS_ERROR =
  'SET_USER_PRESENCE_STATUS_ERROR';
